export const Deduct = (props: React.SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" {...props}>
		<path
			d="M8.66675 7.44484C8.48218 7.44485 8.19414 7.44484 8.19414 7.44484H7.76142L7.33342 7.44483H3.58341C3.07715 7.44483 2.66675 7.85523 2.66675 8.36149C2.66675 8.86775 3.07715 9.27816 3.58341 9.27816H7.33342H7.76142H8.19414H8.66675H9.16675H12.9167C13.423 9.27816 13.8334 8.86775 13.8334 8.36149C13.8334 7.85523 13.423 7.44483 12.9167 7.44483H9.16675C9.16675 7.44483 8.86201 7.44484 8.66675 7.44484Z"
			fill="currentColor"
		/>
	</svg>
);
